import React from 'react';
import styled from 'styled-components';
//
import Image from 'components/image-bg';
import Video from 'components/video-bg';
//
export default ({ children, hoverImage, image, videoUrl }) => (
  <ImageWrap>
    {videoUrl && <Video url={videoUrl} />}
    {!videoUrl && image && image.url && <Image image={image} />}
    {hoverImage && hoverImage.url && (
      <Image image={hoverImage} className="hoverImage" />
    )}
    {children}
  </ImageWrap>
);
//
const ImageWrap = styled.div`
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;

  .hoverImage {
    bottom: 0;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 1;
  }

  &:hover {
    .hoverImage {
      opacity: 1;
    }
  }
`;
